//中正指纹仪
function get_device_type(call_back_fun) { // 获取设备，获取指纹特征前先要调用该函数
    var ws = new WebSocket("ws://localhost:32101/finger");
    ws.onopen = function(evt) {
        var command = "FPIDevDetect";
      ws.send(command);
      }
    ws.onmessage = function(evt) {
        ws.close();
        var resp = eval('('+evt.data+')');
        call_back_fun(resp.result, resp.data);
    };
    ws.onclose = function(evt) {};
  }
  
  function get_dev_version(port, call_back_fun) {
    var ws = new WebSocket("ws://localhost:32101/finger");
    ws.onopen = function(evt) {
        var command = "FPIGetVersion|"+port;
        ws.send(command);
      }
    ws.onmessage = function(evt) {
        ws.close();
        var resp = eval('('+evt.data+')');
        call_back_fun(resp.result, resp.data);
    };
    ws.onclose = function(evt) {};
  }
  
  function get_feature(port, call_back_fun) { // 获取部分指纹特征
    var ws = new WebSocket("ws://localhost:32101/finger");
    ws.onopen = function(evt) {
        var command = "FPIGetFeatureWithoutDlg|"+port;
        ws.send(command);
      }
    ws.onmessage = function(evt) {
        ws.close();
        var resp = eval('('+evt.data+')');
        call_back_fun(resp.result, resp.data);
    };
    ws.onclose = function(evt) {};
  }
  
  function get_template(port, call_back_fun) { //采集指纹，一般需要连续按三次
    var ws = new WebSocket("ws://localhost:32101/finger");
    ws.onopen = function(evt) {
        var command = "FPIGetTemplateWithoutDlg|"+port;
        ws.send(command);
      }
    ws.onmessage = function(evt) {
        ws.close();
        var resp = eval('('+evt.data+')');
        call_back_fun(resp.result, resp.data);
    };
    ws.onclose = function(evt) {};
  }
  export default {
    get_device_type,
    get_feature
  }